import React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { HelpOutlineOutlined as HelpIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';

import { StyledTooltip } from '../../theme/styledElements';
import { spacingInRems } from '../../theme/themeUtils';

const StyledDiv = styled.div`
  && {
    display: flex;
    justify-content: center;
    //margin-top: ${spacingInRems(0.5)};
    .helpIconText {
      font-size: ${spacingInRems()};
      .helpIcon {
        position: relative;
        width: 1.6rem;
        height: 1.6rem;
        top: 0.3rem;
        margin-left: 0.2rem;
      }
    }
  }
`;

const Tooltip = ({ text, tooltipTextContent }) => {
  return (
    <StyledDiv data-testid={'service-fee-tooltip'}>
      <Typography className={'helpIconText'}>
        {text || null}
        <StyledTooltip
          className={'tooltip'}
          title={tooltipTextContent}
          placement={'top-end'}
          arrow
        >
          <HelpIcon
            color={'secondary'}
            className={'helpIcon'}
            data-testid={'help-icon'}
            variable={'outlined'}
          />
        </StyledTooltip>
      </Typography>
    </StyledDiv>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string,
  tooltipTextContent: PropTypes.string.isRequired
};

export default Tooltip;
